<template>
  <div class="container container--narrow">
    <div class="mgt-200">
        <img src="images/level/no-level-data.svg" class="no-degree-image mgx-auto" alt="">
        <div class="t-headline8 t-center mgt-24 font-r">{{$t('3438')}}</div>
        <div class="t-body1 t-color-bodyGrayA  mgt-4 t-center font-r">{{$t('3439')}}</div>
    </div>
  </div>
</template>

<script>
// Components/Mixin/Extend/API define



export default {
  //props: ["status"],
  name: "",
  data() {
    return {
      statusTab: null,
    };
  },
  components: {
    
  },
  watch: {
    $route(to, from) {
      this.statusTab = this.$route.query.status;
    },
  },

  mounted() {
    this.statusTab = this.$route.query.status;
  }
};
</script>

<style scoped>
.no-board-data img {
    height: 143px;
    width: auto;
}
</style>